import { createSlice } from "@reduxjs/toolkit";

export const ticketSourceSlice = createSlice({
  name: "ticketSource",
  initialState: {
    getTicketSourceResult: false,
    getTicketSourceLoading: false,
    getTicketSourceError: false,
    addTicketSourceResult: false,
    addTicketSourceLoading: false,
  },
  reducers: {
    ticketSourceReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TICKETSOURCE":
          return {
            ...state,
            getTicketSourceResult: payload.data,
            getTicketSourceLoading: payload.loading,
            getTicketSourceError: payload.error,
          };
        case "ADD_TICKETSOURCE":
          return {
            ...state,
            addTicketSourceResult: payload.data,
            addTicketSourceLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { ticketSourceReducers } = ticketSourceSlice.actions;

export default ticketSourceSlice.reducer;
